import { fetchApi } from "../../app/lib/api"
import { Types } from './types'
import { actionLoading } from '../home/actions'
import { checkErrorCode } from '../auth/actions'
import { LIMIT_PAGE, LIMIT_PAGE_MODAL } from '../../lib/common'
import { actionGetListUserBank } from "../userClient/actions"

export const actionGetDepositByTransaction = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/get-detail-money-transaction`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionGetDataWithDrawGoldByTransaction = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/detail-withdraw-gold`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionGetDataWithDrawMoneyByTransaction = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/detail-withdraw-money`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}


export const actionGetDataBuySellByTransaction = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/detail-buy-sell`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionGetDataReferralByTransaction = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/detail-referral`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionGetDataKycByTransaction = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/detail-kyc`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionGetDataMasterSendGold = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/config/detail-history-admin`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

//Money Transaction
export const actionGetListMoneyTransaction = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/transaction/get-list-money-transaction`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListMoneyTransaction(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}


//Confrim Transaction Money
export const actionConfrimTransasctionMoney = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/confirm-deposit`, "post", dataPush)
        console.log("Confrim Transaction Money", response.data);
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListMoneyTransaction(filterModal))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        console.log(error || error?.message)

    }
}
//Cancel Transaction Money
export const actionCancelTransasctionMoney = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/cancel-deposit`, "post", dataPush)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListMoneyTransaction(filterModal))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        console.log(error || error?.message)
    }
}


//Withdraw Money Transaction
//Withdraw Money
export const actionGetListWithdrawMoney = (payload = null) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/transaction/list-withdraw-money`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE,
            }
        }
        await dispatch(actionSaveListWihtdrawMoney(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionSaveListWihtdrawMoney = (payload) => ({
    type: Types.SAVE_LIST_WITHDRAW_MONEY_TRANSACTION,
    payload,
})

export const actionGetListWithdrawUSDT = (payload = null) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/transaction/list-withdraw-usdt`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE,
            }
        }
        await dispatch(actionSaveListWithdrawUSDT(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionGetListDepositUSDT = (payload = null) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/transaction/list-deposit-usdt`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE,
            }
        }
        await dispatch(actionSaveListDepositUSDT(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionSaveListDepositUSDT = (payload) => ({
    type: Types.SAVE_LIST_DEPOSIT_USDT,
    payload,
})

export const actionSaveListWithdrawUSDT = (payload) => ({
    type: Types.SAVE_LIST_WITHDRAW_USDT,
    payload,
})

export const actionCancelTransasctionWithdrawUSDT = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/cancel-withdraw-usdt`, "post", dataPush)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListWithdrawMoney(filterModal))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionAcceptTransasctionWithdrawUSDT = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/accept-withdraw-usdt`, "post", dataPush)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListWithdrawMoney(filterModal))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        console.log(error || error?.message)
    }
}

//Confrim Transaction Withdraw Money
export const actionConfrimTransasctionWithdrawMoney = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/success-withdraw-money`, "post", dataPush)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListWithdrawMoney(filterModal))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        console.log(error || error?.message)

    }
}
//Cancel Transaction Withdraw Money
export const actionCancelTransasctionWithdrawMoney = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/cancel-withdraw-money`, "post", dataPush)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListWithdrawMoney(filterModal))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionSaveListMoneyTransaction = (payload) => ({
    type: Types.SAVE_LIST_MONEY_TRANSACTION,
    payload,
})

export const actionSaveAllBank = (payload) => ({
    type: Types.SAVE_ALL_BANK,
    payload,
})

export const actionGetAllbank = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/payment/get-all-bank`, "get", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionSaveAllBank(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}


//Request Claim
export const actionGetListRequestClaim = (payload = null) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/transaction/list-request-claim`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE,
            }
        }
        await dispatch(actionSaveListRequestClaim(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionSaveListRequestClaim = (payload) => ({
    type: Types.SAVE_LIST_REQUEST_CLAIM,
    payload,
})

export const actionConfrimRequestClaim = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/success-request-claim`, "post", dataPush)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListRequestClaim(filterModal))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        console.log(error || error?.message)

    }
}

//Bank Transaction
export const actionGetListBank = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/payment/get-list-bank`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListBank(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionGetListBankByUser = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/user/list-bank-by-user`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListBank(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionDeleteUsersBank = (payload) => async (dispatch, getState) => {
    const { id, user_id, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/user/delete-user-bank`, "post", { id, user_id })
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionGetListBankByUser({ ...filterModal, user_id }))
        await dispatch(actionGetListUserBank({ page: 1, limit: 10 }))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionUpdateListBank = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/payment/update-bank`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        //thêm
        if (!payload.id) {
            await dispatch(actionGetListBank(filterModal))
        }
        //sửa
        else {
            const state = getState()
            const dataListBank = state?.postReducer?.dataListBank
            let newData = { ...dataListBank }

            const index = newData.rows.findIndex(it => it.id === payload.id)
            newData.rows[index] = response.data
            await dispatch(actionGetListBank(filterModal))
        }
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionDeleteBank = (payload) => async (dispatch, getState) => {
    const { id, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/payment/delete-bank`, "post", { id })
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionGetListBank(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionSaveListBank = (payload) => ({
    type: Types.SAVE_LIST_BANK_TRANSACTION,
    payload,
})
//Bank Transaction
export const actionGetListBankConfig = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/payment/get-list-bank-config`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListBankConfig(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionUpdateListBankConfig = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true));
        console.log('actionUpdateListBankConfig');
        let response = await fetchApi(`/admin/payment/update-bank-config`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        //thêm
        if (!payload.id) {
            await dispatch(actionGetListBankConfig(filterModal))
        }
        //sửa
        else {
            const state = getState()
            const dataListBank = state?.postReducer?.dataListBank
            let newData = { ...dataListBank }

            const index = newData.rows.findIndex(it => it.id === payload.id)
            newData.rows[index] = response.data
            await dispatch(actionGetListBankConfig(filterModal))
        }
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionDeleteBankConfig = (payload) => async (dispatch, getState) => {
    const { id, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/payment/delete-bank-config`, "post", { id })
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionGetListBankConfig(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionSaveListBankConfig = (payload) => ({
    type: Types.SAVE_LIST_BANK_CONFIG,
    payload,
})

//////////////////////////////////END/////////////////////////////////////

//GOLD Transaction
export const actionGetTransactionGold = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/transaction/list-withdraw-gold`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE,

            }
        }
        await dispatch(actionSaveListGoldTransaction(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)

    }
}
//GOLD Transaction BUY & SELL
export const actionGetListTransactionBuySellGold = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/transaction/list-buy-sell`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE,

            }
        }
        await dispatch(actionSaveListTransactionBuySellGold(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)

    }
}
export const actionSaveListTransactionBuySellGold = (payload) => ({
    type: Types.SAVE_LIST_TRANSACTION_BUY_SELL_GOLD,
    payload,
})


//////////////////////         Transaction GOLD           /////////////////////////////////////////
export const actionConfrimTransasctionGold = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/confirm-withdraw-gold`, "post", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetTransactionGold(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        return null

    }
}
export const actionCancelTransasctionGold = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/cancel-withdraw-gold`, "post", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetTransactionGold(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)

    }
}
export const actionSuccessTransasctionGold = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/success-withdraw-gold`, "post", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetTransactionGold(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)

    }
}

export const actionGetListModalGold = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, user_id } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/transaction/list-withdraw-gold`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE,
                status: [2],
                user_id: user_id
            }
        }
        await dispatch(actionSaveListModalGoldTransaction(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionGetListCommissionsAgents = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/transaction/list-commissions-agents`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE,
                // status: [2],
                // user_id: user_id
            }
        }
        await dispatch(saveListCommissionsAgents(response.data))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

//end chuyển vàng
export const saveListCommissionsAgents = (payload) => ({
    type: Types.SAVE_LIST_COMMISSIONS_AGENTS,
    payload,
})


//chuyển vàng
export const actionGetListTranferGold = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/gold_price/get-list-transfer-gold`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))

        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE,
                // status: [2],
                // user_id: user_id
            }
        }
        await dispatch(actionSaveListTranferGold(response.data))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionSendGoldListUser = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/transaction/send-gold-to-list-user`, "post", payload.dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        dispatch(getSendGoldListUser({ page: 1, limit: 10 }))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const getSendGoldListUser = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload
        let response = await fetchApi(`/admin/transaction/get-send-gold-to-list`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / limit),
                limit: limit
            }
        }
        dispatch(actionSaveListSendGoldToUser(response.data))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetListHistorySwapCoin = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = 30
        let response = await fetchApi(`/admin/transaction/list-hng-swap`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))

        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / 30),
                limit: 30,
                // status: [2],
                // user_id: user_id
            }
        }
        await dispatch(actionSaveListSwapHNG(response.data))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionGetListSwapHNGTele = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = 30
        let response = await fetchApi(`/admin/payment/get-history-hng-swap-teleapp`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))

        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / 30),
                limit: 30,
                // status: [2],
                // user_id: user_id
            }
        }
        await dispatch(actionSaveListSwapHNGTele(response.data))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionGetListBuyXAUTele = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = 30
        let response = await fetchApi(`/admin/payment/get-list-buy-xau-teleapp`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))

        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / 30),
                limit: 30,
                // status: [2],
                // user_id: user_id
            }
        }
        await dispatch(actionSaveListBuyXAUTele(response.data))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionGetListSellXAUTele = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = 30
        let response = await fetchApi(`/admin/payment/get-list-sell-xau-teleapp`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))

        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / 30),
                limit: 30,
                // status: [2],
                // user_id: user_id
            }
        }
        await dispatch(actionSaveListSellXAUTele(response.data))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionGetListHistorySwapUSD= (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = 30
        let response = await fetchApi(`/admin/transaction/list-usd-swap`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))

        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / 30),
                limit: 30,
                // status: [2],
                // user_id: user_id
            }
        }
        await dispatch(actionSaveListBuyUSDT(response.data))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionGetListHistorySwapXAU= (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = 30
        let response = await fetchApi(`/admin/transaction/list-xau-swap`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))

        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / 30),
                limit: 30,
                // status: [2],
                // user_id: user_id
            }
        }
        await dispatch(actionSaveListSwapXAU(response.data))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionGetListHistorySwapTON = (payload) => async (dispatch, getState) => {
    try {
        const limit = 20
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = limit
        let response = await fetchApi(`/admin/transaction/list-ton-swap`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))

        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / 30),
                limit: limit,
                // status: [2],
                // user_id: user_id
            }
        }
        await dispatch(actionSaveListSwapTON(response.data))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}

export const actionGetListStakingDaily = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload || {}
        if (!payload)
            payload = {}
        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/transaction/list-staking-daily`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))

        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE,
                // status: [2],
                // user_id: user_id
            }
        }
        await dispatch(actionSaveListStakingDaily(response.data))
        return response.data
    } catch (error) {
        console.log(error || error?.message)
    }
}
export const actionSaveListStakingDaily = (payload) => ({
    type: Types.SAVE_LIST_STAKING_DAILY,
    payload,
})
export const actionSaveListSwapHNG = (payload) => ({
    type: Types.SAVE_LIST_SWAP_HNG,
    payload,
})
export const actionSaveListSwapHNGTele = (payload) => ({
    type: Types.SAVE_LIST_SWAP_HNG_TELE,
    payload,
})
export const actionSaveListBuyXAUTele = (payload) => ({
    type: Types.SAVE_LIST_BUY_XAU_TELE,
    payload,
})
export const actionSaveListSellXAUTele = (payload) => ({
    type: Types.SAVE_LIST_SELL_XAU_TELE,
    payload,
})
//end chuyển vàng
export const actionSaveListModalGoldTransaction = (payload) => ({
    type: Types.SAVE_LIST_MODAL_GOLD_TRANSACTION,
    payload,
})
export const actionSaveListTranferGold = (payload) => ({
    type: Types.SAVE_LIST_TRANFER_GOLD,
    payload,
})

export const actionSaveListGoldTransaction = (payload) => ({
    type: Types.SAVE_LIST_GOLD_TRANSACTION,
    payload,
})

export const actionSaveListSendGoldToUser = (payload) => ({
    type: Types.SAVE_LIST_SEND_GOLD,
    payload,
})

export const actionSaveListBuyUSDT = (payload) => ({
    type: Types.SAVE_LIST_SWAP_USD,
    payload,
})

export const actionSaveListSwapXAU = (payload) => ({
    type: Types.SAVE_LIST_SWAP_XAU,
    payload,
})

export const actionSaveListSwapTON = (payload) => ({
    type: Types.SAVE_LIST_SWAP_TON,
    payload,
})
//////////////////////////////////END/////////////////////////////////////
